import { ChangeDetectorRef, Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Router } from '@angular/router';
import { forkJoin, map, Observable, startWith } from 'rxjs';
import {
  DeliveryAddress,
  ProfileDataModel,
  ProfileDataRequest,
  ProfileUpdateAddress,
  ProfileUpdatePassword,
} from 'src/app/api/models/perfil';
import { RGPDLabs, RGPDPreferences } from 'src/app/api/models/rgpdLabs';
import { StorageKeys } from 'src/app/api/models/storageKeys';
import { AuthService, RgpdService } from 'src/app/api/services';
import { CustomIconsService } from 'src/app/api/services/custom-icons.service';
import { EncryptionService } from 'src/app/api/services/encryption.service';
import { PerfilService } from 'src/app/api/services/perfil.service';
import { SnackBarService } from 'src/app/api/services/snack-bar.service';

@Component({
    selector: 'app-perfil',
    templateUrl: './perfil.component.html',
    styleUrls: ['./perfil.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PerfilComponent {
  isLoading: boolean = false;
  isEditing: boolean = false;
  showPassword: boolean = false;

  loggedUser: ProfileDataRequest = this.perfilService.getCurrentUserInfo();
  userData!: ProfileDataModel;
  moradaDefeito!: DeliveryAddress;
  @ViewChild('myForm') myForm: any;

  canChangeAddress: boolean = false;
  password: string = '';
  selectedAddress: string = '';
  passwordChanged: boolean = false;
  addressChanged: boolean = false;

  isProfileUpdate: boolean = true;

  blockedLabs: RGPDLabs[] = [];
  mainLabs: RGPDLabs[] = [];
  selectionControl = new FormControl<string[]>([]);
  otherLabs: RGPDLabs[] = [];
  selectedOtherLabs: RGPDLabs[] = []; 
  otherLabsControl = new FormControl<string[]>([]); 
  labCtrl = new FormControl('');
  filteredLabs!: Observable<any[]>;
  loadedPreferences: boolean = false;

  constructor(
    private perfilService: PerfilService,
    private snackBarService: SnackBarService,
    public authService: AuthService,
    private router: Router,
    private encrypt: EncryptionService,
    private rgpdService: RgpdService,
    private cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit() {
    this.getUserDetails(true);

    this.loadClientRGPDPreferences();

    this.filteredLabs = this.labCtrl.valueChanges.pipe(
      startWith(''),
      map(value => {
        const searchValue = typeof value === 'string' ? value : '';
        return this._filter(searchValue);
      })
    );
  }

  getUserDetails(isUpdating: boolean): void {
    this.isLoading = true;

    this.perfilService.getUserProfileData(this.loggedUser.clientId, this.loggedUser.userId, this.isProfileUpdate)  
      .subscribe({
        next: (resp) => {
          this.userData = resp;

          if(isUpdating){
            localStorage.removeItem("BIO2_User");
            localStorage.removeItem("BIO2_AddressId");
            this.encrypt.setEncryptedItem("BIO2_User", JSON.stringify(resp));
            this.encrypt.setEncryptedItem("BIO2_AddressId", resp.userInfo.preferedDeliveryAddressId)
          }

          if (this.loggedUser.role != 'Administrador') {
            this.moradaDefeito = resp.deliveryAddresses.find(x => x.deliveryAddressId == resp.userInfo.preferedDeliveryAddressId)! ?? {} as DeliveryAddress;
          }
          else {
            let decryptedAdress = this.encrypt.getDecryptedItem("BIO2_AddressId");
            this.moradaDefeito = resp.deliveryAddresses.find(x => x.deliveryAddressId == decryptedAdress)! ?? {} as DeliveryAddress;
          }
        },
        error: (e) => console.error(e),
        complete: () => {
          this.isLoading = false;
          isUpdating = false;
        }
      });
  }


  onSaveData() {
    this.isLoading = true;
    const requestAddress: ProfileUpdateAddress = {
      userId: this.loggedUser.userId,
      deliveryAddressId: this.selectedAddress
    }
    const requestPass: ProfileUpdatePassword = {
      userId: this.loggedUser.userId,
      password: this.password,
    }

    const obsvAddress = this.perfilService.updatePrefAddress(requestAddress);
    const obsvPassword = this.perfilService.updatePassword(requestPass);

    if (this.passwordChanged && this.addressChanged) {
      // Handle the case when both password and address are changed.
      obsvAddress.subscribe((resp) => {
        obsvPassword.subscribe((resp2) => {
          const valid = !!(resp && resp2);
          this.snack(valid);
        });
      });

    } else if (this.passwordChanged) {
      // Handle the case when only the password is changed.
      obsvPassword.subscribe((resp) => {
        this.snack(resp);
      });

    } else if (this.addressChanged) {
      // Handle the case when only the address is changed.
      obsvAddress.subscribe((resp) => {
        this.snack(resp);
      });

    }

    this.setPreferences()

    setTimeout(() => {
      this.getUserDetails(true);
      this.myForm.resetForm();
      this.addressChanged = false;
      this.passwordChanged = false;
      this.isEditing = false;
      this.isLoading = false;
    }, 1000);
  }

  inputPassChanged(): void {
    this.passwordChanged = !!(this.password);
  }

  onAddressChange(value: any) {
    if (this.loggedUser.role === 'Administrador' && this.moradaDefeito) {
      localStorage.removeItem("BIO2_AddressId");
      this.encrypt.setEncryptedItem('BIO2_AddressId', value.value);
      this.getUserDetails(false);
    }
    this.selectedAddress = value.value;
    this.addressChanged = !!(this.selectedAddress && this.selectedAddress != this.moradaDefeito.deliveryAddressId);
  }

  onLogout(): void {
    this.authService.clearSessionStorage();
    this.encrypt.clear();
    this.router.navigate(['/login']);
  }

  onChangeClient(): void {
    this.router.navigate(['/login/selection/subLogin']);
  }

  snack(valid: boolean): void {
    if (valid) {
      this.snackBarService.openSnackBar(
        'Alterações guardadas com sucesso.',
        '#0AA174',
        '../../../assets/Icons/correct.png'
      );
    }
    else {
      this.snackBarService.openSnackBar(
        'Erro ao guardar as alterações.',
        '#F97066',
        '../../../assets/Icons/ErrorIcon.png'
      );
    }
  }

  loadClientRGPDPreferences(): void {
    
    forkJoin({
      mainLabs: this.rgpdService.getMainRgpdLabs(), 
      otherLabs: this.rgpdService.getOthersRgpdLabs(), 
      preferences: this.rgpdService.getPreferencesByUser(this.loggedUser?.clientId)
    }).subscribe({
      next: (data) => {
        this.mainLabs = data.mainLabs;
        this.otherLabs = data.otherLabs;
        this.blockedLabs = data.preferences;
        
        // Set main labs using FormControl
        const selectedMainIds = this.mainLabs
          .filter(mainLab => this.blockedLabs.some(b => b.id === mainLab.id))
          .map(lab => lab.id);
        this.selectionControl.setValue(selectedMainIds);

        // Set other labs - both for FormControl and chips display
        const selectedOtherLabs = this.otherLabs
          .filter(otherLab => this.blockedLabs.some(b => b.id === otherLab.id));
        
        const selectedOtherIds = selectedOtherLabs.map(lab => lab.id);
        this.otherLabsControl.setValue(selectedOtherIds);
        this.selectedOtherLabs = selectedOtherLabs; // For chips display
        
        this.loadedPreferences = true;
      },
      error: (err) => {
        this.loadedPreferences = true;
        console.error('Error loading data', err);
      }
    });
  }

  private _filter(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.otherLabs.filter(lab =>
      lab.labName.toLowerCase().includes(filterValue) &&
      !this.selectedOtherLabs.some(sel => sel.id === lab.id)
    );
  }

  selectLab(event: any): void {
    const selectedLab = event.option.value;
    
    // Add to chips display array
    if (!this.selectedOtherLabs.some(lab => lab.id === selectedLab.id)) {
      this.selectedOtherLabs.push(selectedLab);
      
      // Update the FormControl with IDs
      const currentIds = this.otherLabsControl.value || [];
      this.otherLabsControl.setValue([...currentIds, selectedLab.id]);
    }
    
    // Clear the input and trigger filter refresh
    this.labCtrl.setValue('');
    
    // Optional: Force refresh of filteredLabs
    this.refreshFilteredLabs();
  }

  removeLab(labToRemove: any): void {
    // Remove from chips display array
    this.selectedOtherLabs = this.selectedOtherLabs.filter(lab => lab.id !== labToRemove.id);
    
    // Update the FormControl
    const currentIds = this.otherLabsControl.value || [];
    this.otherLabsControl.setValue(currentIds.filter(id => id !== labToRemove.id));
    
    // Refresh filtered labs to show the removed lab again
    this.refreshFilteredLabs();
  }

  private refreshFilteredLabs(): void {
    // Force the filteredLabs observable to recalc
    const currentValue = this.labCtrl.value || '';
    // Emit the current value to retrigger the filtering
    this.labCtrl.setValue(currentValue);
  }

  setPreferences(): void {   
    const clientId = this.loggedUser?.clientId;

    const preferences: RGPDPreferences = {
      n_Cliente: clientId,
      id_Labs: [
        ...(this.selectionControl.value || []),
        ...(this.otherLabsControl.value || []) 
      ]    
    };

    this.rgpdService.setPreferences(preferences).subscribe({
      next: () => {
        this.router.navigate(['/home']);
      },
      error: (err) => {
        console.error('Error saving preferences', err);
      }
    });
  }

  get preferedAddressId(): any {
    return this.loggedUser.role === 'Administrador'
      ? this.moradaDefeito?.deliveryAddressId
      : +this.userData?.userInfo?.preferedDeliveryAddressId;
  }

  set preferedAddressId(value: any) {
    if (this.loggedUser.role === 'Administrador') {
      this.moradaDefeito.deliveryAddressId = value;
    } else {
      this.userData.userInfo.preferedDeliveryAddressId = value;
    }
  }
}
